// Import components
import "../../components/material-toggle.js";
import "../../components/paper-options.js";
import "../../components/acryl-options.js";
import "../../components/aluminium-options.js";
import "../../components/gift-options.js";
import "../../components/wallable-watermark.js";

import "html2canvas";
import "@woocommerce/woocommerce-rest-api";
import "cropperjs/dist/cropper.css";
import Cropper from "cropperjs";
import axios from "axios";
import html2canvas from "html2canvas";
import * as $ from "jquery";
import * as bootstrap from "bootstrap";
import hyroxArchive from "./hyrox/events.json";
import {
  uploadImage,
  uploadProductScreenshot,
} from "./helpers/image-uploader.js";
import { getShippingDate } from "./helpers/shipping-date.js";
import { resizePosterPreview } from "./helpers/resize-poster-preview.js";
import { getShoppingBagSummary } from "./helpers/shopping-bag-summary.js";
import { Options } from "./options-hyrox-poster.js";
import { DebugReporter } from "./helpers/debug-reporter.js";
import { initializeI18n } from "./i18n/initialize.js";
import { resolveCatalogProduct } from "./catalog/product-catalog.js";

let woocommerceUrl = process.env.WOOCOMMERCE_URL || window.location.origin;
const apiBase = "";
let marketContext;
let t = (key) => key;
let formatCurrency = (value) => `€${Number(value).toFixed(2).replace(".", ",")}`;
let formatDate = (value) => String(value);
const i18nReady = initializeI18n().then((i18n) => {
  ({ marketContext, t, formatCurrency, formatDate } = i18n);
  woocommerceUrl = marketContext.services.woocommerceBaseUrl;
  getSavedPoster();
  getEventFromQuery();
  toggleProductionEnv();
  calculatePosterPrice();
  resizePosterWrapper();
  toggleClearIcons();
  setPreviewMode();
});

const options = new Options();

let PosterPreviewImage,
  EventsModal,
  cropper,
  HyroxImgUrl,
  HyroxImg,
  AgeGroup,
  Division;
let ShowMobileSettingPanel = false;
const BuilderName = $("body").attr("id");
let EventsInitialized = false;
let PrintTypeSelected = true;

let SettingsPanel = options.get("settingsPanel", "map");
let PosterSize = options.get("posterSize", "small");
let PosterFrame = options.get("posterFrame", "black");
let AcrylBlock = options.get("acrylBlock", "black");
let AluminiumColor = options.get("aluminiumColor", "silver");
let PrintType = options.get("printType", "paper");
let GiftCardText = "";

const ContestantNameInput = $("#contestant-name-input");
const ContestantNameLabel = $(".labels .contestant-name");
const LocationInput = $("#location-input");
const LocationLabel = $(".js-location");
const ShortInput = $("#short-input");
const ShortLabel = $(".js-short");
const DivisionsSelector = $(".js-division-select");
const DivisionLabel = $(".js-division");
const AgeGroupSelector = $(".js-age-group-select");
const AgeGroupLabel = $(".js-age-group");
const DateInput = $("#date-input");
const DateLabel = $(".js-date");
const FinishTimeInput = $("#finish-time-input");
const FinishTimeLabel = $(".js-finish-time");
const PosterWrapper = $(".map-wrapper");
const PosterSizeSelect = $(".js-poster-size");
const PosterFrameSelect = $(".js-poster-frame");
const AcrylBlockSelect = $(".js-acryl-block");
const PrintTypeSelect = $(".js-print-type");
const PosterGiftwrapSelect = $(".js-giftwrap");
const GiftCardSelect = $(".js-giftcard");
const ImageWrapper = $(".hyrox-image");
const eventsList = $(".js-events-list");
const CropImage = document.getElementById("crop-image");
const savePosterButton = $(".js-save-poster");

const debugReporter = DebugReporter({
  ajaxUrl: apiBase + "/wp-json/wallable/v1/client-diagnostics",
  containerSelector: ".js-notifications",
  shouldShow: ({ meta }) =>
    meta?.action === "add-to-cart" || meta?.action === "add-poster-order",
  extraContext: () => ({
    builder: $("body").attr("id"),
  }),
}).init();

// For dismissing panel if previewing from shopping cart
function setPreviewMode() {
  const urlParams = new URLSearchParams(window.location.search);
  if (urlParams.has("preview")) {
    dismissSettingsPanel();
  }
}

$(document).ready(function () {
  window.status = "mapbox-ready";
  setTimeout(() => {
    $(".anim-wrapper").removeClass("hidden");
    $(".loading-wrapper").remove();
  }, "500");
});

// Input listeners
$("input.form-control").on("input", function () {
  const posterLabel = this.dataset.posterLabel;

  if (!posterLabel) return;

  const inputValue = $(this).val();

  $(".js-" + posterLabel).html(inputValue);

  $('.js-clear-input[data-field-id="' + posterLabel + '"]').toggle(
    inputValue !== "",
  );
});

$(".js-history-back").on("click", function () {
  history.back();
});

// Clear input fields
$(".js-clear-input").on("click", function () {
  const field = $(this).data("field-id");

  if (field === "search-list") {
    $('input.form-control[data-poster-label="search-list"]')
      .val("")
      .trigger("input")
      .trigger("focus");

    loadStoredEvents();
    return;
  }

  $(
    'input.form-control[data-poster-label="' +
      field +
      '"], textarea.form-control[data-poster-label="' +
      field +
      '"]',
  )
    .val("")
    .trigger("input")
    .trigger("focus");
});

// Check if field has value and show clear icon
function toggleClearIcons() {
  const inputFields = $("input.form-control");
  const textAreas = $("textarea.form-control");

  inputFields.each(function () {
    const inputValue = $(this).val();

    if (inputValue.trim() === "") {
      let emptyField = $(this).data("poster-label");
      $('.js-clear-input[data-field-id="' + emptyField + '"]').hide();
    }
  });

  textAreas.each(function () {
    const inputValue = $(this).val();

    if (inputValue.trim() === "") {
      let emptyField = $(this).data("poster-label");
      $('.js-clear-input[data-field-id="' + emptyField + '"]').hide();
    }
  });
}

// Changing poster
function setPosterSize(posterSize) {
  PosterWrapper.removeClass().addClass(
    "map-wrapper size-" + posterSize + " " + PrintType,
  );
}

// Change poster size
$(".js-size-option").on("click", function () {
  PosterSize = $(this).attr("data-size");
  setPosterSize(PosterSize);
  setSizeSelection(PosterSize);
  calculatePosterPrice();
});

function setSizeSelection(posterSize) {
  let selectedSize = $(
    '.js-toggle-for-material[data-material="' +
      PrintType +
      '"] .js-size-option[data-size="' +
      posterSize +
      '"]',
  );

  $(".js-size-option").removeClass("active");
  selectedSize.addClass("active");

  if (PrintType !== "paper") return;

  let framePrice = 0;
  let frameNormalPrice = 0;
  switch (posterSize) {
    case "small":
      framePrice = 15;
      frameNormalPrice = 21.95;
      break;
    case "medium":
      framePrice = 20;
      frameNormalPrice = 24.95;
      break;
    case "large":
      framePrice = 35;
      frameNormalPrice = 39.95;
      break;
    default:
      framePrice = 0;
      frameNormalPrice = 0;
  }

  // If extra-large, force no frame
  if (posterSize === "extra-large") {
    PosterFrame = "no-frame";
    setFrameSelection(PosterFrame);
    setPosterFrame(PosterFrame);
    $(".js-frame-option").addClass("disabled");
    $('.js-frame-option[data-frame="no-frame"]').removeClass("disabled");
    $("small[frame-normal-price]").text("-");
    $("small[frame-price]").hide();
  } else {
    $(".js-frame-option").removeClass("disabled");
    $("small[frame-price]").show();
    $("small[frame-price]").text(
      formatCurrency(framePrice),
    );
    $("small[frame-normal-price]").text(
      formatCurrency(frameNormalPrice),
    );

    $(".js-frame-option")
      .not('[data-frame="no-frame"]')
      .attr("data-price", framePrice.toFixed(2));
  }
}

// Change print type
$(document).on("click", ".js-print-option", function () {
  let SelectedPrintType = $(this).attr("data-print");
  if (PrintType !== SelectedPrintType) {
    PrintType = SelectedPrintType;
    setPrintType(PrintType);
  }
  if ($(this).hasClass("d-block")) {
    PrintTypeSelected = true;
  }
  togglePrintTypes();
});

$(document).on("click", ".js-show-print-types", function () {
  togglePrintTypes();
});

function setPrintType(PrintType) {
  var selectedPrint = $('.js-print-option[data-print="' + PrintType + '"]');
  $(".js-print-option").removeClass("active");
  selectedPrint.addClass("active");

  // If acryl
  if (PrintType == "acryl") {
    if (PosterSize === "large" || PosterSize === "extra-large") {
      PosterSize = "small";
    }
    PosterFrame = "no-frame";

    // If aluminium
  } else if (PrintType == "aluminium") {
    if (PosterSize === "large" || PosterSize === "extra-large") {
      PosterSize = "medium";
    }
    PosterFrame = "no-frame";
    setAluminiumColor(AluminiumColor);

    // If paper
  } else {
    if (PosterSize === "xs") {
      PosterSize = "small";
    } else if (PosterSize === "extra-large") {
      PosterSize = "large";
    }
    AcrylBlock = "no-block";
  }
  setAcrylBlock(AcrylBlock);
  setBlockSelection(AcrylBlock);
  setFrameSelection(PosterFrame);
  setPosterFrame(PosterFrame);
  setPosterSize(PosterSize);
  setSizeSelection(PosterSize);
  calculatePosterPrice();
}

function togglePrintTypes() {
  if (PrintTypeSelected) {
    $(".js-print-option").hide();
    $(".js-toggle-for-material").hide();
    $(".js-show-print-types").show();
    $(".js-toggle-for-material[data-material='" + PrintType + "']").show();
    $(".js-print-option[data-print='" + PrintType + "']").show();
    PrintTypeSelected = false;
  } else {
    $(".js-print-option").show();
    $(".js-show-print-types").hide();
    $(".js-toggle-for-material").hide();
    PrintTypeSelected = true;
  }
}

// Change aluminium color
$(".js-color-option").on("click", function () {
  AluminiumColor = $(this).attr("data-color");
  setAluminiumColor(AluminiumColor);
  setAluminiumColorSelection(AluminiumColor);
});

function setAluminiumColor(color) {
  PosterWrapper.attr("data-aluminium-color", color);
}

function setAluminiumColorSelection(color) {
  var selectedColor = $('.js-color-option[data-color="' + color + '"]');
  $(".js-color-option").removeClass("active");
  selectedColor.addClass("active");
}

// Change acryl block
$(".js-block-option").on("click", function () {
  AcrylBlock = $(this).attr("data-block");
  setBlockSelection(AcrylBlock);
  setAcrylBlock(AcrylBlock);
  calculatePosterPrice();
});

function setBlockSelection(AcrylBlock) {
  var selectedBlock = $('.js-block-option[data-block="' + AcrylBlock + '"]');
  $(".js-block-option").removeClass("active");
  selectedBlock.addClass("active");
}

function setAcrylBlock(AcrylBlock) {
  $(".aluminium-stand").hide();
  $(".acryl-block").show();
  PosterWrapper.attr("data-perspective", false);
  if (AcrylBlock == "black") {
    $(".acryl-block").removeClass("d-none oak").addClass("black");
    PosterWrapper.attr("data-perspective", true);
  } else if (AcrylBlock == "oak") {
    $(".acryl-block").removeClass("d-none black").addClass("oak");
    PosterWrapper.attr("data-perspective", true);
  } else {
    $(".acryl-block").removeClass("oak black").addClass("d-none");
  }
}

// Change poster frame
$(".js-frame-option").on("click", function () {
  PosterFrame = $(this).attr("data-frame");
  setFrameSelection(PosterFrame);
  setPosterFrame(PosterFrame);
  activateGiftwrap();
  calculatePosterPrice();
});

function setPosterFrame(PosterFrame) {
  const frameElement = $(".poster-frame");
  const frameClasses = ["black-frame", "oak-frame", "white-frame"];

  frameElement.removeClass(frameClasses.join(" ") + " d-none");

  if (frameClasses.includes(PosterFrame + "-frame")) {
    frameElement.addClass(PosterFrame + "-frame");
  } else {
    frameElement.addClass("d-none");
  }
  activateGiftwrap();
}

function setFrameSelection(frame) {
  var selectedFrame = $('.js-frame-option[data-frame="' + frame + '"]');
  $(".js-frame-option").removeClass("active");
  selectedFrame.addClass("active");
}

// Toggle giftwrap
$(".js-giftwrap").on("change", function () {
  calculatePosterPrice();
});

function activateGiftwrap() {
  if (PrintType === "paper" && PosterFrame === "no-frame") {
    PosterGiftwrapSelect.val("false");
    $(".js-giftwrap option[value=true]")
      .attr("disabled", "disabled")
      .siblings()
      .removeAttr("disabled");
  } else {
    $(".js-giftwrap option[value=true]").removeAttr("disabled");
  }
}

// Change giftcard text
$(".js-giftcard").on("change", function () {
  if ($(this).val() === "true") {
    $(".js-giftcard-text").show();
    GiftCardText = $(".js-giftcard-text").val();
  } else {
    $(".js-giftcard-text").hide();
    GiftCardText = "";
  }
  calculatePosterPrice();
});

$(".js-giftcard-text").on("change", function () {
  GiftCardText = $(this).val();
});

// Get list of divisions
function loadDivisions() {
  DivisionsSelector.append(
    `<option value="" disabled>${t("hyrox.event.division")}</option>`,
  );
  hyroxArchive.divisions.forEach((division) => {
    DivisionsSelector.append(
      `<option value="${division.division}">${division.division}</option>`,
    );
  });
}

DivisionsSelector.on("change", function () {
  Division = $(this).val();
  DivisionLabel.html(Division);
  loadAgeGroups(Division);
  AgeGroupSelector.val(AgeGroup);
});

// Get list of age groups
function loadAgeGroups(Division) {
  AgeGroupSelector.children().remove().end();
  const ageGroups = hyroxArchive["age-groups"][0][Division];
  AgeGroupSelector.append(
    `<option value="" disabled>${t("hyrox.event.ageGroup")}</option>`,
  );

  ageGroups.forEach((ageGroup) => {
    AgeGroupSelector.append(
      `<option value="${ageGroup.group}">${ageGroup.group}</option>`,
    );
  });
}

AgeGroupSelector.on("change", function () {
  AgeGroup = $(this).val();
  AgeGroupLabel.html(AgeGroup);
});

// Get list of stored routes
function loadStoredEvents() {
  eventsList.html("");
  hyroxArchive.events.sort((a, b) => a.timestamp - b.timestamp);

  hyroxArchive.events.reverse().forEach((event) => {
    eventsList.append(
      `<div class="col"><div class="card h-100 cursor-pointer js-load-pred-event" data-event-id="${event.id}"><div class="img-wrap"><div class="badge badge-info">${event.short}</div><img src="${event.imgUrl}" class="card-img-top" alt="..."></div><div class="card-body"><h6 class="card-title">HYROX ${event.location}</h6><small class="mb-0">${event.date}</small></div></div></div>`,
    );
  });

  initEventsList();
}

function initEventsList() {
  $(".js-load-pred-event").on("click", function () {
    loadStoredEvent($(this).data("event-id"));
    EventsModal.hide();
    setTimeout(() => {
      dismissSettingsPanel();
    }, 500);
  });
}

function loadStoredEvent(eventID) {
  const event = hyroxArchive.events.find((item) => item.id === eventID);

  if (!event) {
    return;
  }

  LocationLabel.html(event.location);
  LocationInput.val(event.location);
  ShortLabel.html(event.short);
  ShortInput.val(event.short);
  DateLabel.html(event.date);
  DateInput.val(event.date);
}

$(".js-init-events").on("click", function () {
  if (!EventsInitialized) {
    loadStoredEvents();
    EventsInitialized = true;
  }
});

// For searching the events list
$("input.js-search-event").on("input", function (e) {
  handleSearch($(this).val());

  if ($(this).val() === "") {
    $('.js-clear-input[data-field-id="search-list"]').hide();
  } else {
    $('.js-clear-input[data-field-id="search-list"]').show();
  }
});

$("input.js-search-event").on("change", function (e) {
  handleSearch($(this).val());
});

function handleSearch(inputVal) {
  let match = searchEvents(inputVal);

  eventsList.html("");

  if (match.length !== 0) {
    match.forEach((event) => {
      eventsList.append(
        `<div class="col"><div class="card h-100 cursor-pointer js-load-pred-event" data-event-id="${event.id}"><div class="img-wrap"><div class="badge badge-info">${event.short}</div><img src="${event.imgUrl}" class="card-img-top" alt="..."></div><div class="card-body"><h6 class="card-title">HYROX ${event.location}</h6><p class="mb-0">${event.date}</p></div></div></div>`,
      );
    });
    initEventsList();
  } else {
    eventsList.append(
      `<p class="text-center w-100">${t("hyrox.event.noResults")}</p>`,
    );
  }
}

function searchEvents(query) {
  // Convert the query to lowercase for case-insensitive search
  query = query.toLowerCase();

  return hyroxArchive.events.filter((event) => {
    const { location, short, date } = event;
    const searchableText = `${location} ${short} ${date}`.toLowerCase();

    return searchableText.includes(query);
  });
}

// For getting predefined route from url var
function getEventFromQuery() {
  const regex = new RegExp("[\\?&]eventID=([^&#]*)");
  const results = regex.exec(window.location.search);
  const routeQueryParam =
    results === null ? "" : decodeURIComponent(results[1].replace(/\+/g, " "));

  if (routeQueryParam !== null && routeQueryParam !== "") {
    loadStoredEvent(parseInt(routeQueryParam));
    dismissSettingsPanel();
  }
}

function hasEventID() {
  return (
    window.location.href.includes("?eventID") ||
    window.location.href.includes("&eventID")
  );
}

// Open image
$("#photo-input").on("change", function (e) {
  var files = e.target.files;
  var done = function (url) {
    $(this).value = "";
    CropImage.src = url;
    if (cropper) {
      cropper.destroy();
    }
    $(".js-save-crop").removeClass("d-none");
    $(".js-upload-image")
      .removeClass("btn-primary")
      .addClass("btn-quarternary");
    initCropper();
  };
  var reader;
  var file;

  if (files && files.length > 0) {
    file = files[0];

    if (URL) {
      done(URL.createObjectURL(file));
    } else if (FileReader) {
      reader = new FileReader();
      reader.onload = function (e) {
        done(reader.result);
      };
      reader.readAsDataURL(file);
    }
  }
});

// Cropper
function initCropper() {
  cropper = new Cropper(CropImage, {
    dragMode: "none",
    viewMode: 1,
    aspectRatio: 1 / 0.8,
    autoCropArea: 1,
    restore: false,
    guides: true,
    center: true,
    highlight: false,
    cropBoxMovable: true,
    cropBoxResizable: true,
    toggleDragModeOnDblclick: false,
    background: false,
    zoom(event) {
      const maxZoomRatio = 2;
      const minZoomRatio = 1;

      if (
        event.detail.ratio > maxZoomRatio ||
        event.detail.ratio < minZoomRatio
      ) {
        event.preventDefault();
      }
    },
  });
}

$(".js-save-crop").on("click", function () {
  var croppedCanvas;

  if (cropper) {
    // Crop
    croppedCanvas = cropper.getCroppedCanvas({
      maxWidth: 4000,
      maxHeight: 4000,
    });
    HyroxImg = croppedCanvas.toDataURL("image/jpeg", 1);

    // Check image resolution
    // checkImageResolution(HyroxImg)
    //   .then((result) => {
    //     if (!result.isValid) {
    //       console.warn(result.warning);
    //       $(".js-resolution-alert").removeClass("d-none");
    //     } else {
    //       console.log(result.message);
    //       $(".js-resolution-alert").addClass("d-none");
    //     }
    //   })
    //   .catch((error) => {
    //     console.error("Error:", error.message);
    //   });

    // Show
    addImageToUI(HyroxImg);
  }
});

function addImageToUI(imageURL) {
  HyroxImg = imageURL;

  // 1) altijd meteen renderen (URL of dataURL)
  ImageWrapper.find("style").remove();
  ImageWrapper.append(
    `<style>.hyrox-image::before { background-image: url(${HyroxImg}); }</style>`,
  );

  // 2) alleen als het een URL is (dus NIET data:image/)
  if (
    BuilderName !== "PrintApp" &&
    typeof HyroxImg === "string" &&
    HyroxImg &&
    !HyroxImg.startsWith("data:image/")
  ) {
    (async () => {
      try {
        const base64 = await convertImageToBase64(HyroxImg);
        ImageWrapper.find("style").remove();
        ImageWrapper.append(
          `<style>.hyrox-image::before { background-image: url(${base64}); }</style>`,
        );
      } catch (err) {
        console.log("Failed to convert image:", err);
      }
    })();
  }

  $(".js-hyrox-photo").attr("src", HyroxImg);
}

async function convertImageToBase64(imageUrl) {
  try {
    const proxyUrl = `https://app.scrapingbee.com/api/v1/?api_key=${
      process.env.SCRAPING_BEE_API_KEY
    }&url=${encodeURIComponent(imageUrl)}&render_js=false`;

    const response = await axios.get(proxyUrl, { responseType: "arraybuffer" });
    const base64Image = Buffer.from(response.data).toString("base64");

    return `data:image/png;base64,${base64Image}`;
  } catch (error) {
    console.error("Error fetching image via ScrapingBee:", error);
    throw error;
  }
}

function checkImageResolution(base64Image) {
  return new Promise((resolve, reject) => {
    const img = new Image();

    // Set up the event listeners
    img.onload = () => {
      const { width, height } = img;

      if (width < 1000 || height < 1000) {
        resolve({
          isValid: false,
          warning: `The image resolution is too low: ${width}x${height}px. Minimum required is 1000x1000px.`,
        });
      } else {
        resolve({
          isValid: true,
          message: `The image resolution is sufficient: ${width}x${height}px.`,
        });
      }
    };

    img.onerror = () => {
      reject(
        new Error("Unable to load the image. Please check the Base64 string."),
      );
    };

    // Set the image source to the Base64 string
    img.src = base64Image;
  });
}

// Calculate poster price
function calculatePosterPrice() {
  const getPrice = (selector) =>
    parseFloat($(selector).find(".active, :selected").attr("data-price")) || 0;

  const subtotalPrice =
    getPrice(PosterSizeSelect) +
    getPrice(AcrylBlockSelect) +
    getPrice(PosterFrameSelect) +
    getPrice(PosterGiftwrapSelect) +
    getPrice(GiftCardSelect);

  $(".subtotal").html(formatCurrency(subtotalPrice));
}

// Create poster preview image
function createPosterPreview() {
  $(".poster-frame, .block-wrapper").addClass("hidden");
  $(".map-wrapper").addClass("shadow-none");
  const element = document.querySelector(".poster-wrapper");

  html2canvas(element, {
    scale: window.devicePixelRatio || 2,
    useCORS: true,
    backgroundColor: "#ffffff",
  }).then((canvas) => {
    PosterPreviewImage = canvas.toDataURL("image/jpeg", 0.8);
    $(".js-poster-preview").attr("src", PosterPreviewImage);
  });
  $(".map-wrapper").removeClass("shadow-none");
  $(".poster-frame, .block-wrapper").removeClass("hidden");
}

// For hiding some unnecessary fields on staging
function toggleProductionEnv() {
  if (process.env.OAK_FRAMES === "false") {
    $('[data-frame="oak"]').remove();
  }
  if (process.env.ACRYL_PRODUCTS === "false") {
    if (PrintType === "acryl") {
      PrintType = "paper";
      PosterWrapper.removeClass("acryl");
    }
    $(".js-show-for-acryl").remove();
    $(".js-hide-for-acryl").show();
    $(".js-material-toggle [data-print='acryl']").remove();
  }
  if (process.env.ALUMINIUM_PRODUCTS === "false") {
    if (PrintType === "aluminium") {
      PrintType = "paper";
      PosterWrapper.removeClass("aluminium");
    }
    $(".js-show-for-aluminium").remove();
    $(".js-hide-for-aluminium").show();
    $(".js-material-toggle [data-print='aluminium']").remove();
  }
}

// For saving design to local storage
function saveDesign() {
  localStorage.setItem("posterSize", PosterSize);
  localStorage.setItem("posterFrame", PosterFrame);
  localStorage.setItem("ContestantName", ContestantNameLabel.html());
  localStorage.setItem("HyroxLocation", LocationLabel.html());
  localStorage.setItem("HyroxShort", ShortLabel.html());
  localStorage.setItem("HyroxDivision", DivisionLabel.html());
  localStorage.setItem("HyroxAgeGroup", AgeGroupLabel.html());
  localStorage.setItem("HyroxDate", DateLabel.html());
  localStorage.setItem("HyroxFinishTime", FinishTimeLabel.html());
  localStorage.setItem("printType", PrintType);
  localStorage.setItem("acrylBlock", AcrylBlock);
  localStorage.setItem("aluminiumColor", AluminiumColor);
  if (
    typeof HyroxImg === "string" &&
    HyroxImg &&
    !HyroxImg.startsWith("data:image/")
  ) {
    localStorage.setItem("HyroxImg", HyroxImg);
  }
}

// For getting design from local storage or parameters
function getSavedPoster() {
  // Prepare text labels
  if (BuilderName !== "PrintApp") {
    EventsModal = new bootstrap.Modal(document.getElementById("events-modal"));

    // Hide error on close modal
    document
      .getElementById("events-modal")
      .addEventListener("hide.bs.modal", function (event) {
        $(".js-alert-songtext").addClass("d-none");
      });

    if (options.get("ContestantName") !== null) {
      var ContestantName = options.get("ContestantName");
    } else {
      var ContestantName = t("hyrox.editor.defaultName");
    }

    if (options.get("HyroxLocation") !== null) {
      var Location = options.get("HyroxLocation");
    } else {
      var Location = t("hyrox.editor.location");
    }

    if (options.get("HyroxShort") !== null) {
      var Short = options.get("HyroxShort");
    } else {
      var Short = "AFK";
    }

    if (options.get("HyroxDivision") !== null) {
      var Division = options.get("HyroxDivision");
    } else {
      var Division = "Open";
    }

    if (options.get("HyroxAgeGroup") !== null) {
      var AgeGroup = options.get("HyroxAgeGroup");
    } else {
      var AgeGroup = t("hyrox.editor.defaultAgeGroup");
    }

    if (options.get("HyroxDate") !== null) {
      var HyroxDate = options.get("HyroxDate");
    } else {
      var HyroxDate = t("hyrox.editor.date");
    }

    if (options.get("HyroxFinishTime") !== null) {
      var FinishTime = options.get("HyroxFinishTime");
    } else {
      var FinishTime = t("hyrox.editor.defaultFinishTime");
    }

    if (options.get("HyroxImg") !== null) {
      var HyroxImg = options.get("HyroxImg");
    } else {
      var HyroxImg =
        "https://ik.imagekit.io/wallable/Hyrox-events/woman-hyrox-placeholder.jpg";
    }
  } else {
    var ContestantName = options.get("ContestantName");
    var Location = options.get("HyroxLocation");
    var Short = options.get("HyroxShort");
    var Division = options.get("HyroxDivision");
    var AgeGroup = options.get("HyroxAgeGroup");
    var HyroxDate = options.get("HyroxDate");
    var FinishTime = options.get("HyroxFinishTime");
    var HyroxDate = options.get("HyroxDate");
    var HyroxImg = options.get("HyroxImg");
  }

  // Set text labels
  ContestantNameLabel.html(ContestantName);
  ContestantNameInput.val(ContestantName);
  LocationLabel.html(Location);
  LocationInput.val(Location);
  ShortLabel.html(Short);
  ShortInput.val(Short);
  DivisionLabel.html(Division);
  DivisionsSelector.val(Division);
  DateLabel.html(HyroxDate);
  DateInput.val(HyroxDate);
  FinishTimeLabel.html(FinishTime);
  FinishTimeInput.val(FinishTime);

  // Set image
  addImageToUI(HyroxImg);

  if (BuilderName !== "PrintApp") {
    setBlockSelection(AcrylBlock);
    setAcrylBlock(AcrylBlock);
  }

  if (PrintType !== "acryl" && PrintType !== "aluminium") {
    if (PosterSize === "xs") {
      PosterSize = "small";
    }
    if (PrintType === "framed-poster" || PrintType === "tegel") {
      PrintType = "paper";
    }
  }
  setPosterSize(PosterSize);
  setAluminiumColor(AluminiumColor);
  setAluminiumColorSelection(AluminiumColor);
  $(".js-toggle-for-material").hide();
  togglePrintTypes();
  PosterFrameSelect.val(PosterFrame);
  PrintTypeSelect.val(PrintType);
  setPrintType(PrintType);
  activateGiftwrap();

  loadDivisions();
  loadAgeGroups(Division);
  DivisionsSelector.val(Division);
  AgeGroupLabel.html(AgeGroup);
  AgeGroupSelector.val(AgeGroup);
}

// Resize canvas
$(window).resize(function () {
  resizePosterWrapper();
});

function resizePosterWrapper() {
  resizePosterPreview();
}

window.visualViewport?.addEventListener("resize", resizePosterWrapper);

// Toggle settings panels
$(".js-settings-toggle").on("click", function () {
  var target = $(this).attr("data-target");
  $(".nav-link").removeClass("active");
  $(".nav-link[data-target=" + target + "]").addClass("active");

  if (target == "text" && SettingsPanel !== "text") {
    $(".settings-panel").addClass("d-none");
    $(".settings-panel.text").removeClass("d-none");
    SettingsPanel = "text";
  } else if (target == "size" && SettingsPanel !== "size") {
    $(".settings-panel").addClass("d-none");
    $(".settings-panel.size").removeClass("d-none");
    SettingsPanel = "size";
  } else if (target == "shop" && SettingsPanel !== "shop") {
    setPosterSummary();
    $(".settings-panel").addClass("d-none");
    $(".settings-panel.shop").removeClass("d-none");
    $(".nav-pills .nav-link").removeClass("active");
    $("#pills-shop-tab").addClass("active");
    SettingsPanel = "shop";
  }

  if (ShowMobileSettingPanel == false) {
    $(".side-nav").addClass("shown");
    ShowMobileSettingPanel = true;
  }
  $(".options-container").scrollTop(0);
  saveDesign();
});

$(".js-close-settings").on("click", function () {
  dismissSettingsPanel();
});

function dismissSettingsPanel() {
  $(".side-nav").removeClass("shown");
  ShowMobileSettingPanel = false;
}

// Prepping shopping cart
function setPosterSummary() {
  getShoppingBagSummary(PosterSize, PrintType, PosterFrame, AcrylBlock, t);
  $(".js-shipping-date").html(getShippingDate({ t, formatDate }));
  createPosterPreview();
}

function getProductVariation() {
  const variationKey = PrintType === "paper" ? `${PosterSize}-${PosterFrame}` : PosterSize;
  const product = resolveCatalogProduct(marketContext.catalog, "hyrox", PrintType, variationKey);
  return { id: product?.id ?? null, variation_id: product?.variationId ?? null };
}

const handleUploadImage = async (HyroxImg) => {
  savePosterButton.html(t("hyrox.actions.savingImage")).prop("disabled", true);
  try {
    // Wait for the promise to resolve
    HyroxImgUrl = await uploadImage(HyroxImg, "hyrox");
    if (HyroxImgUrl === null || HyroxImgUrl === undefined) {
      savePosterButton
        .html(t("actions.addToCart"))
        .prop("disabled", false);
      $(".js-notifications").append(
        `<div class="js-error alert alert-danger text-center p-2">${t("hyrox.errors.photoSaveFailed")}</div>`,
      );
    } else {
      localStorage.setItem("HyroxImg", HyroxImgUrl);
      addToCart();
    }
  } catch (error) {
    console.error("Error uploading image:", error);
    savePosterButton.html(t("actions.addToCart")).prop("disabled", false);
    $(".js-notifications").append(
      `<div class="js-error alert alert-danger text-center p-2">${t("hyrox.errors.photoSaveFailed")}</div>`,
    );
  }
};

function isPrintApp() {
  return $("html").hasClass("PrintApp");
}

// Add poster to cart
$(".js-save-poster").on("click", function () {
  saveDesign();

  if (typeof HyroxImg === "string" && HyroxImg.startsWith("data:image/")) {
    handleUploadImage(HyroxImg);
  } else {
    HyroxImgUrl = HyroxImg;
    addToCart();
  }
});

// Adding poster to cart
async function addToCart() {
  let ProductID = getProductVariation();

  savePosterButton
    .html(
      `${t("actions.savingDesign")} <span class="spinner-border spinner-border-sm ms-2" aria-hidden="true"></span>`,
    )
    .prop("disabled", true);

  let thumbnailUrl;
  try {
    thumbnailUrl = await uploadProductScreenshot(
      PosterPreviewImage,
      BuilderName,
    );
  } catch (error) {
    console.error("Product screenshot kon niet worden opgeslagen", error);
    savePosterButton.html(t("actions.addToCart")).prop("disabled", false);
    $(".js-notifications").append(
      `<div class="js-error alert alert-danger text-center p-2">${t("hyrox.errors.previewSaveFailed")}</div>`,
    );
    return;
  }

  let payload = {
    "add-builder-item-to-cart": true,
    edit_url: woocommerceUrl + "/builder/hyrox-poster/?preview",
    thumbnail: thumbnailUrl,
    product_id: ProductID.id,
    variation_id: ProductID.variation_id,
    poster: {
      printType: PrintType,
      size: PosterSize,
      giftwrap: PosterGiftwrapSelect.val(),
      giftcardText: GiftCardText,
      ContestantName: localStorage.getItem("ContestantName"),
      HyroxLocation: localStorage.getItem("HyroxLocation"),
      HyroxShort: localStorage.getItem("HyroxShort"),
      HyroxDivision: localStorage.getItem("HyroxDivision"),
      HyroxAgeGroup: localStorage.getItem("HyroxAgeGroup"),
      HyroxDate: localStorage.getItem("HyroxDate"),
      HyroxFinishTime: localStorage.getItem("HyroxFinishTime"),
      HyroxImg: HyroxImgUrl,
      ...(["aluminium"].includes(PrintType) && {
        aluminiumColor: localStorage.getItem("aluminiumColor"),
      }),
      ...(["aluminium", "acryl"].includes(PrintType) && {
        acrylBlock: localStorage.getItem("acrylBlock"),
      }),
      ...(["paper"].includes(PrintType) && {
        frame: PosterFrame,
      }),
      main: "Hyrox " + localStorage.getItem("HyroxLocation"),
      subtitle: localStorage.getItem("ContestantName"),
    },
    pdf: {
      type: "hyrox",
      print:
        PrintType === "paper" && PosterFrame !== "no-frame"
          ? "framed-poster"
          : PrintType,
    },
  };

  // console.log("Payload: ", payload);

  let action =
    process.env.USE_CART === "true" ? "add-to-cart" : "add-poster-order";
  const endpoint = apiBase + "/wp-json/wallable/v1/" + action;
  let didRetryAsForm = false;

  const runAjax = (useFormEncoding = false) => {
    return $.ajax({
      url: endpoint,
      type: "POST",
      timeout: 20000,

      ...(useFormEncoding
        ? {
            data: { payload: JSON.stringify(payload) },
          }
        : {
            contentType: "application/json",
            data: JSON.stringify(payload),
          }),

      error: (jqXHR, textStatus, errorThrown) => {
        if (!useFormEncoding && !didRetryAsForm && jqXHR?.status === 0) {
          didRetryAsForm = true;
          return runAjax(true);
        }

        console.error(jqXHR, textStatus, errorThrown);

        setTimeout(() => {
          if (!$(".js-notifications").find(".js-error").length) {
            $(".js-notifications").append(
              `<div class="js-error alert alert-danger text-center p-2">${t("errors.generic")}</div>`,
            );
          }

          debugReporter.show({
            meta: { action, didRetryAsForm },
            request: {
              url: endpoint,
              method: "POST",
              mode: useFormEncoding ? "form" : "json",
              origin: window.location.origin,
              woocommerceUrl,
              online: navigator.onLine,
              visibilityState: document.visibilityState,
            },
            response: {
              status: jqXHR?.status,
              statusText: jqXHR?.statusText || textStatus,
              thrownError: errorThrown ? String(errorThrown) : null,
              responseText: (jqXHR?.responseText || "").slice(0, 4000),
            },
          });

          savePosterButton
            .html(t("actions.addToCart"))
            .prop("disabled", false);
        }, 500);
      },

      success: () => {
        if (action === "add-to-cart") {
          savePosterButton
            .html(t("actions.addToCart"))
            .prop("disabled", false);

          window.location = woocommerceUrl + "/cart/";
        } else {
          if (!$(".js-notifications").find(".js-error").length) {
            $(".js-notifications").append(
              `<div class="js-success alert alert-success text-center p-2">&#x2713; ${t("actions.posterAdded")}</div>`,
            );
          }
          savePosterButton
            .html(t("actions.addToCart"))
            .prop("disabled", false);
        }
      },
    });
  };

  runAjax(false);
}

// Tooltips
if (!isPrintApp()) {
  var tooltipTriggerList = [].slice.call(
    document.querySelectorAll('[data-bs-toggle="tooltip"]'),
  );
  var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
    return new bootstrap.Tooltip(tooltipTriggerEl);
  });
}
